var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('VButton',{staticClass:"donate",attrs:{"size":_vm.size}},[_c('i',{staticClass:"icon cc-letterheart-filled margin-right-small padding-top-smaller"}),_vm._t("default",null,{"default":""})],2)}
var staticRenderFns = []

export { render, staticRenderFns }